import FlashLib from "flashlib";

import Main from "./Main";

import PreloaderProgressBar from "./preloader/PreloaderProgressBar";

import UiContainer from "Base/ui/BaseUiContainer";
import BetContainer from "Base/ui/BaseBetContainer";
import BalanceContainer from "Base/ui/BaseBalanceContainer";
import WinContainer from "Base/ui/BaseWinContainer";
import TotalWinContainer from "Base/ui/BaseTotalWinContainer";
import SpinButton from "Base/ui/BaseSpinButton";
import CheckBox from "Base/ui/CheckBox";
import MobileSpinButton from "Base/uiMobile/BaseMobileSpinButton";

import BaseUiMobileContainer from "Base/uiMobile/BaseUiMobileContainer";
import BaseUiMobilePortraitContainer from "Base/uiMobilePortrait/BaseUiMobilePortraitContainer";
import BaseUiMobileLandscapeContainer from "Base/uiMobileLandscape/BaseUiMobileLandscapeContainer";
import BaseMobileBalanceContainer from "Base/uiMobile/BaseMobileBalanceContainer";
import BaseMobileBetContainer from "Base/uiMobile/BaseMobileBetContainer";
import BaseMobileWinContainer from "Base/uiMobile/BaseMobileWinContainer";
import BaseMobileTotalWinContainer from "Base/uiMobile/BaseMobileTotalWinContainer";
import BaseMobileMenuPortraitPopupContainer from "Base/uiMobilePortrait/BaseMobileMenuPortraitPopupContainer";
import BaseMobileMenuLandscapePopupContainer from "Base/uiMobileLandscape/BaseMobileMenuLandscapePopupContainer";
import BaseMobileMenu2LandscapePopupContainer from "Base/uiMobileLandscape/BaseMobileMenu2LandscapePopupContainer";
import BaseMobileCheckBox from "Base/uiMobile/BaseMobileCheckBox";

import MobilePortraitAutoPlayPanelContainer from "Base/uiMobilePortrait/autoplayPanel/BaseMobilePortraitAutoPlayPanelContainer";
import MobileLandscapeAutoPlayPanelContainer from "Base/uiMobileLandscape/autoplayPanel/BaseMobileLandscapeAutoPlayPanelContainer";

import AutoPlayPopupContainer from "Base/ui/autoPlayPopup/BaseAutoPlayPopupContainer";
import AutoPlayStartButton from "Base/ui/autoPlayPopup/BaseAutoPlayStartButton";
import AutoPlaySelectCountContainer from "Base/ui/autoPlayPopup/BaseAutoPlaySelectCountContainer";
import AutoPlaySelectButton from "Base/ui/autoPlayPopup/BaseAutoPlaySelectButton";
import AutoPlayStopSettingsContainer from "Base/ui/autoPlayPopup/BaseAutoPlayStopSettingsContainer";
import AutoPlayButton from "Base/ui/BaseAutoPlayButton";

import BasePopupContainer from "Base/popups/BasePopupContainer";
import ClockContainer from "Base/clock/ClockContainer";

import BetPopupContainer from "Base/ui/betPopup/BaseBetPopupContainer";
import BetPopupCheckBox from "Base/ui/betPopup/BaseBetPopupCheckBox";
import MenuPopupContainer from "Base/ui/BaseMenuPopupContainer";
import BetProgressContainer from "Base/ui/BaseBetProgressContainer";

import BaseSlotLine from "Engine/slots/lines/BaseSlotLine";
import SlotReel from "./reels/SlotReel";
import ReelsContainer from "./reels/ReelsContainer";
import Symbol from "./symbols/Symbol";
import WildSymbol from "./symbols/WildSymbol";
import BaseButton from "Base/ui/BaseGameButton";
import BaseCheckBox from "Engine/base/ui/BaseCheckBox"

import BaseMobilePaytableLandscapeContainer from "Base/paytableMobileLandscape/BaseMobilePaytableLandscapeContainer";
import BaseMobileBetLandscapePopupContainer from "Base/paytableMobileLandscape/BaseMobileBetLandscapePopupContainer";

import BaseMobilePaytablePortraitContainer from "Base/paytableMobilePortrait/BaseMobilePaytablePortraitContainer";
import BaseMobileBetPortraitPopupContainer from "Base/paytableMobilePortrait/BaseMobileBetPortraitPopupContainer";

import PaytableContainer from "Base/paytable/BasePaytableContainer";
import PaytableInfoContainer from "Base/paytable/BasePaytableInfoContainer";
import PaytableSettingsContainer from "Base/paytable/BasePaytableSettingsContainer";
import PaytableRulesContainer from "Base/paytable/BasePaytableRulesContainer";
import PaytableScrollBarContainer from "Base/paytable/BasePaytableScrollBarContainer";
import SymbolsPaysContainer from "Base/paytable/BaseSymbolsPaysContainer";
import SymbolPaysContainer from "Base/paytable/BaseSymbolPaysContainer";

import BackgroundContainer from "./background/BackgroundContainer";
import BackgroundMobileContainer from "./background/BackgroundMobileContainer";
import DecorationsContainer from "./decorations/DecorationsContainer";
import LogoContainer from "./logo/LogoContainer";
import SymbolsAnimationsContainer from "./symbolsAnimations/SymbolsAnimationsContainer";
import BigWinContainer from "./bigWin/BigWinContainer";
import LineWinningContainer from "./lineWIn/LineWinningContainer";

import FreeSpinsWindowContainer from "./freeSpins/FreeSpinsWindowContainer";

import SplashScreenContainer from "./splashScreen/SplashScreenContainer";

import WildsContainer from "./wilds/WildsContainer";
import NearWinContainer from "Engine/slots/nearWin/NearWinContainer";

import RealityCheckContainer from "Base/realityCheck/RealityCheckContainer";
import OverlayContainer from "Base/overlay/OverlayContainer";
import TopMessageContainer from "Base/topMessage/TopMessageContainer";

FlashLib.registerClass('Main', Main);
FlashLib.registerClass('PreloaderProgressBar', PreloaderProgressBar);
FlashLib.registerClass('UiContainer', UiContainer);
FlashLib.registerClass('BetContainer', BetContainer);
FlashLib.registerClass('BalanceContainer', BalanceContainer);
FlashLib.registerClass('WinContainer', WinContainer);
FlashLib.registerClass('TotalWinContainer', TotalWinContainer);
FlashLib.registerClass('SpinButton', SpinButton);
FlashLib.registerClass('CheckBox', CheckBox);
FlashLib.registerClass('AutoPlayPopupContainer', AutoPlayPopupContainer);
FlashLib.registerClass('AutoPlayStartButton', AutoPlayStartButton);
FlashLib.registerClass('AutoPlaySelectCountContainer', AutoPlaySelectCountContainer);
FlashLib.registerClass('AutoPlaySelectButton', AutoPlaySelectButton);
FlashLib.registerClass('AutoPlayStopSettingsContainer', AutoPlayStopSettingsContainer);
FlashLib.registerClass('AutoPlayButton', AutoPlayButton);
FlashLib.registerClass('PopupContainer', BasePopupContainer);
FlashLib.registerClass('ClockContainer', ClockContainer);
FlashLib.registerClass('BetPopupContainer', BetPopupContainer);
FlashLib.registerClass('BetPopupCheckBox', BetPopupCheckBox);
FlashLib.registerClass('MenuPopupContainer', MenuPopupContainer);
FlashLib.registerClass('BetProgressContainer', BetProgressContainer);
FlashLib.registerClass('BaseSlotLine', BaseSlotLine);
FlashLib.registerClass('SlotReel', SlotReel);
FlashLib.registerClass('ReelsContainer', ReelsContainer);
FlashLib.registerClass('Symbol', Symbol);
FlashLib.registerClass('WildSymbol', WildSymbol);
FlashLib.registerClass('BaseButton', BaseButton);
FlashLib.registerClass('BaseCheckBox', BaseCheckBox);
FlashLib.registerClass('PaytableContainer', PaytableContainer);
FlashLib.registerClass('PaytableScrollBarContainer', PaytableScrollBarContainer);
FlashLib.registerClass('PaytableSettingsContainer', PaytableSettingsContainer);
FlashLib.registerClass('PaytableInfoContainer', PaytableInfoContainer);
FlashLib.registerClass('PaytableRulesContainer', PaytableRulesContainer);
FlashLib.registerClass('SymbolsPaysContainer', SymbolsPaysContainer);
FlashLib.registerClass('SymbolPaysContainer', SymbolPaysContainer);
FlashLib.registerClass('BackgroundContainer', BackgroundContainer);
FlashLib.registerClass('BackgroundMobileContainer', BackgroundMobileContainer);
FlashLib.registerClass('DecorationsContainer', DecorationsContainer);
FlashLib.registerClass('LogoContainer', LogoContainer);
FlashLib.registerClass('SymbolsAnimationsContainer', SymbolsAnimationsContainer);
FlashLib.registerClass('BigWinContainer', BigWinContainer);
FlashLib.registerClass('LineWinningContainer', LineWinningContainer);
FlashLib.registerClass('FreeSpinsWindowContainer', FreeSpinsWindowContainer);
FlashLib.registerClass('SplashScreenContainer', SplashScreenContainer);
FlashLib.registerClass('WildsContainer', WildsContainer);
FlashLib.registerClass('NearWinContainer', NearWinContainer);

FlashLib.registerClass('MobilePaytablePortraitContainer', BaseMobilePaytablePortraitContainer);
FlashLib.registerClass('MobileBetPopupPortraitContainer', BaseMobileBetPortraitPopupContainer);

FlashLib.registerClass('MobilePaytableLandscapeContainer', BaseMobilePaytableLandscapeContainer);
FlashLib.registerClass('MobileBetPopupLandscapeContainer', BaseMobileBetLandscapePopupContainer);

FlashLib.registerClass('UiMobilePortraitContainer', BaseUiMobilePortraitContainer);
FlashLib.registerClass('UiMobileLandscapeContainer', BaseUiMobileLandscapeContainer);

FlashLib.registerClass('MobileMenuPortraitPopupContainer', BaseMobileMenuPortraitPopupContainer);
FlashLib.registerClass('MobileMenuLandscapePopupContainer', BaseMobileMenuLandscapePopupContainer);
FlashLib.registerClass('MobileMenu2LandscapePopupContainer', BaseMobileMenu2LandscapePopupContainer);

FlashLib.registerClass('UiMobileContainer', BaseUiMobileContainer);

FlashLib.registerClass('MobileBalanceContainer', BaseMobileBalanceContainer);
FlashLib.registerClass('MobileBetContainer', BaseMobileBetContainer);
FlashLib.registerClass('MobileWinContainer', BaseMobileWinContainer);
FlashLib.registerClass('MobileTotalWinContainer', BaseMobileTotalWinContainer);
FlashLib.registerClass('MobileCheckBox', BaseMobileCheckBox);

FlashLib.registerClass('RealityCheckContainer', RealityCheckContainer);
FlashLib.registerClass('OverlayContainer', OverlayContainer);

FlashLib.registerClass('MobileSpinButton', MobileSpinButton);

FlashLib.registerClass('MobilePortraitAutoPlayPanelContainer', MobilePortraitAutoPlayPanelContainer);
FlashLib.registerClass('MobileLandscapeAutoPlayPanelContainer', MobileLandscapeAutoPlayPanelContainer);

FlashLib.registerClass('TopMessageContainer', TopMessageContainer);
